import { useTranslation } from 'next-i18next'
import styled, { keyframes } from 'styled-components'

import { breakpoints, colors } from '@/styles'
import { Button } from '@/components/button'

import { SectionTitle, SectionWrapper } from '../elements'
import { ReactComponent as AngleDownSVG } from './angle-down.svg'

const arrowMove = keyframes`
 0% {
   opacity: 0;
   transform: translateY(-4px);
 }
 20% {
    opacity: 0.3;
 }
 50%, 90% {
   opacity: 1;
   transform: translateY(4px);
 }
 100% {
  opacity: 0;
  transform: translateY(4px);
 }
`

const arrowMove2 = keyframes`
 0%, 50% {
   opacity: 0;
   transform: translateY(-4px);
 }
 90% {
   opacity: 1;
   transform: translateY(0px);
 }
 100% {
  opacity: 0;
  transform: translateY(0px);
 }
`

const OuterWrapper = styled(SectionWrapper)`
  display: flex;
  flex-direction: column;
`

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 40px;

  @media (max-width: ${breakpoints.tabletLandscape}) {
    margin: 0 48px;
    gap: 16px;
  }

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    flex-direction: column;
    margin: 0 96px;
  }

  @media (max-width: ${breakpoints.phoneMax}) {
    margin: 0 16px;
  }
`

const IconWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 11px;
  height: 11px;
  margin-left: 8px;

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    margin-left: 16px;
  }
`

const ArrowDown = styled(AngleDownSVG)`
  position: absolute;
  transform: translateY(4px);
`

const ArrowDown2 = styled(AngleDownSVG)`
  position: absolute;
  transform: translateY(0px);
`

const StyledButton = styled(Button)<{ bgColor: string; mainColor: string }>`
  &:hover ${ArrowDown} {
    animation: ${arrowMove} 3s ease infinite;
    path {
      fill: ${props => props.mainColor};
    }
  }

  &:hover ${ArrowDown2} {
    animation: ${arrowMove2} 3s ease infinite;

    path {
      fill: ${props => props.mainColor};
    }
  }

  &:hover {
    background-color: ${props => props.bgColor};
    border-color: ${props => props.mainColor};
    color: ${props => props.mainColor};
  }

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    font-size: 14px;
    line-height: 20px;
  }
`

const ScrollSection = () => {
  const { t } = useTranslation('landlords')

  const CARDS = [
    {
      title: t('landlords:Rental Marketing'),
      id: 'rental-market',
      bgColor: colors.purple96,
      color: colors.purple40
    },
    {
      title: t('landlords:Tenant Screening Report'),
      id: 'screen-report',
      bgColor: colors.red96,
      color: colors.red64
    },
    {
      title: t('landlords:Contracts & Payments'),
      id: 'contract-pay',
      bgColor: colors.green96,
      color: colors.green48
    }
  ]

  const scrolltoSection = (id: string) => {
    const section = document.getElementById(id)
    section?.scrollIntoView({ block: 'start', behavior: 'smooth' })
  }

  return (
    <OuterWrapper>
      <SectionTitle marginBottom={64} textAlign="center">
        {t('landlords:3 Easy ways to optimize your rental process')}
      </SectionTitle>
      <ButtonWrapper>
        {CARDS.map(item => (
          <StyledButton
            key={item?.id}
            id={`landlord-${item?.id}-click`}
            radius={100}
            bgColor={item?.bgColor}
            mainColor={item?.color}
            onClick={() => scrolltoSection(`landlord-${item?.id}-section`)}
          >
            <>
              {item?.title}
              <IconWrapper>
                <ArrowDown width={11} height={7} />
                <ArrowDown2 width={11} height={7} />
              </IconWrapper>
            </>
          </StyledButton>
        ))}
      </ButtonWrapper>
    </OuterWrapper>
  )
}

export default ScrollSection
